import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import Prohead from '@/components/Prohead'
import Proindex from '@/components/Proindex'
import ProRecommend from '@/components/ProRecommend'
import ProRecommending from '@/views/ProRecommending'
import Proadd from '@/components/Proadd'
import newadd from '@/components/newadd'
import Joinus from '@/components/Joinus'
import add from '@/views/add'
import login from '@/views/login'
import contactus from '@/components/contactus'
import newdetails from '@/components/newdetails'
import le from '@/components/le'
import prodetails from '@/components/prodetails'
import zhudetails from '@/components/zhudetails'
Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '开心玩国'
      }

    },
    {
      path: '/le',
      name: 'le',
      component: le,
      meta: {
        title: ''
      }

      // meta: {
      //   belong: "/ProRecommending"
      // }
    },
    {
      path: '/newadd',
      name: 'newadd',
      component: newadd,
      meta: {
        title: '新闻咨讯'
      }

    },
    {
      path: '/zhudetails',
      name: 'zhudetails',
      component: zhudetails,
      meta: {
        title: '新闻详情'
      }

    },
    {
      path: '/prodetails',
      name: 'prodetails',
      component: prodetails,
      meta: {
        title: '产品详情'
      }

    },
    {
      path: '/newdetails',
      name: 'newdetails',
      component: newdetails,
      meta: {
        title: '新闻咨讯'
      }

    },
    {
      path: '/contactus',
      name: 'contactus',
      component: contactus,
      meta: {
        title: '新闻咨讯'
      }
    },
    {
      path: '/Joinus',
      name: 'Joinus',
      component: Joinus,
      meta: {
        title: '新闻咨讯'
      }
    },
    {
      path: '/Prohead',
      name: 'Prohead',
      component: Prohead,
      meta: {
        title: '新闻咨讯'
      }
    },
    {
      path: '/Proindex',
      name: 'Proindex',
      component: Proindex,
      meta: {
        title: '新闻咨讯'
      }
    },
    {
      path: '/ProRecommend',
      name: 'ProRecommend',
      component: ProRecommend,
      meta: {
        title: '新闻咨讯'
      }
    }, {
      path: '/ProRecommending',
      name: 'ProRecommending',
      component: ProRecommending,
      meta: {
        title: '新闻咨讯'
      }
    }, {
      path: '/Proadd',
      name: 'Proadd',
      component: Proadd,
      meta: {
        title: '新闻咨讯'
      }
    }, {
      path: '/add',
      name: 'add',
      component: add,
      meta: {
        title: '新闻咨讯'
      }
    },{
      path: '/login',
      name: 'login',
      component: login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js